export const INITIALIZE_ANALYTICS = 'INITIALIZE_ANALYTICS'
export const INITIALIZE_ANALYTICS_FULFILLED = 'INITIALIZE_ANALYTICS_FULFILLED'
export const INITIALIZE_ANALYTICS_REJECTED = 'INITIALIZE_ANALYTICS_REJECTED'

/**
 * Initializes analytics with the analytics object returned from segment
 * @param {{analytics: class}} [payload]
 */
export const initializeAnalytics = (payload) => ({
  type: INITIALIZE_ANALYTICS,
  payload,
})

export const ANALYTICS_IDENTIFY_USER = 'ANALYTICS_IDENTIFY_USER'
export const ANALYTICS_IDENTIFY_USER_FULFILLED = 'ANALYTICS_IDENTIFY_USER_FULFILLED'
export const ANALYTICS_IDENTIFY_USER_REJECTED = 'ANALYTICS_IDENTIFY_USER_REJECTED'
/**
 * Identify the user for analytics
 * @param {{userId: string|number, traits: object, options: object}} payload
 */
export const identifyUser = (payload) => ({
  type: ANALYTICS_IDENTIFY_USER,
  payload,
})

export const TRACK = 'TRACK'
export const TRACK_FULFILLED = 'TRACK_FULFILLED'
export const TRACK_REJECTED = 'TRACK_REJECTED'
/**
 * Tracks a action event
 * If the action is
 * @param {{event: string, data: object}} [payload]
 */
export const track = (payload) => ({ type: TRACK, payload })

export const GROUP = 'GROUP'
export const GROUP_FULFILLED = 'GROUP_FULFILLED'
export const GROUP_REJECTED = 'GROUP_REJECTED'
/**
 * Groups a user to a groupId
 * If the action is
 * @param {{groupId: string, traits: object}} [payload]
 */
export const group = (payload) => ({ type: GROUP, payload })
